export default "__VITE_ASSET__BwqNFEV$__"